class SisBtn extends HTMLElement {
  connectedCallback() {
    this.querySelector(".sis-trigger")?.addEventListener("click", (e: Event) => {
      e.preventDefault();
      e.stopPropagation();
      stockInStore?.checkStockInStore?.(window);
    });
  }
}

customElements.define("sis-btn", SisBtn);
